import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AnalyticsWeeklyPage } from '@pages/analytics';
import { Skeleton, Stack } from '@shared/ui';

export const Route = createFileRoute('/$locale/_authenticated/analytics-move/weekly/')({
  component: AnalyticsWeeklyRoute,
  pendingComponent: AnalyticsWeeklyPending,
  pendingMs: 0,
  pendingMinMs: 0,
  validateSearch: z.object({
    week: z.string().optional(),
    range: z.string().optional(),
    start: z.string().optional(),
    end: z.string().optional(),
    source: z.enum(['sync/sync', 'postgres/generated']).optional(),
  }),
});

function AnalyticsWeeklyRoute() {
  return <AnalyticsWeeklyPage />;
}

function AnalyticsWeeklyPending() {
  return (
    <Stack gap="md" data-testid="analytics-weekly-pending">
      <Skeleton className="h-10 w-72" />
      <Skeleton className="h-8 w-full" />
      <div className="space-y-2">
        {Array.from({ length: 8 }).map((_, index) => (
          <Skeleton key={`weekly-pending-${String(index)}`} className="h-10 w-full" />
        ))}
      </div>
    </Stack>
  );
}
